import * as React from "react";
import { renderDateAndTime } from "./renderDateAndTime";
export var renderPreliveDetails = function (event, componentPrefix) {
    return React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__times", "data-uat": "div-ev-list-" + componentPrefix + "-times" }, renderDateAndTime(event.eventDate, event.eventTime));
};
//# sourceMappingURL=renderPreliveDetails.js.map